import L from "leaflet";

/** Parse bounds_json whether API returns object or string. */
export function parseBoundsJson(json) {
  if (!json) return null;
  let data = json;
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch (_) {
      return null;
    }
  }
  if (!data?.southWest || !data?.northEast) return null;
  return data;
}

export function boundsFromJson(json) {
  const data = parseBoundsJson(json);
  if (!data) return null;
  return L.latLngBounds(
    [data.southWest.lat, data.southWest.lng],
    [data.northEast.lat, data.northEast.lng]
  );
}

export function normalizePathologyOverlay(ov) {
  if (!ov) return null;
  return {
    ...ov,
    bounds_json: parseBoundsJson(ov.bounds_json),
    overlay_url: overlayUrlWithCache(ov.overlay_url, ov.updated_at || ov.id),
  };
}

export function overlayUrlWithCache(url, version) {
  if (!url || typeof url !== "string") return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (!version) return trimmed;
  const sep = trimmed.includes("?") ? "&" : "?";
  return `${trimmed}${sep}v=${encodeURIComponent(String(version))}`;
}

/**
 * Preload PNG/JPEG overlay then add to map (avoids broken Leaflet image layers).
 */
export function addPathologyImageOverlay(map, ov, options = {}) {
  const bounds = boundsFromJson(ov?.bounds_json);
  const url = ov?.overlay_url;
  if (!map || !bounds || !url) return null;

  const {
    opacity = 1,
    className = "pathology-ai-overlay",
    zIndex = 650,
    onError,
  } = options;

  const layer = L.imageOverlay(url, bounds, {
    opacity,
    interactive: false,
    className,
    zIndex,
  });

  const img = layer.getElement?.();
  if (img) {
    img.referrerPolicy = "no-referrer";
    img.onerror = () => {
      console.warn("[pathology] overlay image failed to load", url);
      onError?.(ov);
    };
  }

  layer.on("add", () => {
    try {
      layer.bringToFront();
      const el = layer.getElement?.();
      if (el) {
        el.style.zIndex = String(zIndex);
        el.style.pointerEvents = "none";
      }
    } catch (_) {
      /* ignore */
    }
  });

  layer.addTo(map);
  return layer;
}

export function isPathologyOverlayRenderable(ov) {
  return Boolean(
    ov?.overlay_url &&
      parseBoundsJson(ov.bounds_json) &&
      (ov.status === "accepted" || ov.status === "preview")
  );
}
